window.addEventListener('DOMContentLoaded', () => {

    const allBtnsOpen = document.querySelectorAll('.cgv-ml-block-title button');
    const allBtnsClose = document.querySelectorAll('.cgv-ml-content button');
    const allContainers = Array.from(document.querySelectorAll('.cgv-ml-block'));

    allBtnsOpen.forEach(btn => {
        btn.addEventListener('click', () => {
            const activeContainer = btn.closest('.cgv-ml-block');

            openBlock(activeContainer)

            allContainers.forEach(container => {
                if(container.classList.contains('active') && container !== activeContainer){
                    
                closeBlock(container);
                }
            })
        })
    })

    allBtnsClose.forEach(btn => {
        btn.addEventListener('click', () => {
            const container = btn.closest('.cgv-ml-block');

            closeBlock(container);
        })
    })

    function closeBlock(container){
        container.classList.remove('active');

        const mainContent = container.querySelector('.cgv-ml-content');
        gsap.to(mainContent, { height:0, duration:0 });
    }

    function openBlock(container){
        const mainContent = container.querySelector('.cgv-ml-content');

        container.classList.add('active');

        gsap.to(mainContent, { height:'auto', duration:0 });
    }

})